export const initialUserState = {
  isLogged: false,
  isLogOuting: false,
  isFetching: false,
  isInitial: true,
  isSending: false,
  isSaved: false,
  isNotSaved: false,
  deletingAttribute: '',
  errors: [],
  messages: [],
  id: null,
  email: '',
  name: '',
  surname: '',
  groups: [],
  defaultCountry: {},
  categories: [],
  currencies: [],
  languages: [],
  locale: '',
  avatar: '',
  subcategoriesSelected: [],
  languagesSelected: [],
  currencyId: null,
  receivedUserInfo: {
    currencyId: undefined,
    currencyCode: null,
    languages: [],
    subcategories: [],
  },
  requisites: {},
};
